import {useOutletContext} from 'react-router-dom'

// Sections
import SalesInformation from '@/containers/Store/PaymentAndTaxView/sections/SalesInformation'
import PaymentInformation from '@/containers/Store/PaymentAndTaxView/sections/PaymentInformation'
const PaymentAndTaxView = () => {
  const {storeData} = useOutletContext()

  return (
    <div>
      <SalesInformation storeData={storeData} />
      <PaymentInformation storeData={storeData} />
    </div>
  )
}

export default PaymentAndTaxView
